import { Controller, useFormContext } from 'react-hook-form';
import { useTheme } from '@mui/material';

import { assignEditableScorecardProperties } from './Panes/Create/Scorecard/components/util';
import { ATSConnectHiringRequestCandidateFeedbackTestIds } from 'data-testids/ATS';
import { RowCTAContainer, StyledLink } from './styles';
import { RowCTAProps } from '../types';
import { useDeleteHiringRequestScorecard } from './mutations';
import { useQueryGetScorecardsForHiringRequest } from './Panes/List/queries';

export const RowCTA: React.FC<RowCTAProps> = ({
  isComplete,
  hiringRequestId,
  onEditScorecardClick,
  scorecardId,
}) => {
  const theme = useTheme();
  const { data: completedScorecards } = useQueryGetScorecardsForHiringRequest(hiringRequestId);
  const { mutate: deleteScorecard } = useDeleteHiringRequestScorecard({});
  const { setValue } = useFormContext();
  const handleDeleteClick = () => {
    deleteScorecard({ hiringRequestId, scorecardId });
  };

  const handleEditClick = (_event, onChange) => {
    const completedScorecard = completedScorecards.find(
      (completedScorecard) => completedScorecard.id === scorecardId
    );

    onChange(scorecardId);
    onEditScorecardClick(scorecardId);

    if (completedScorecard) {
      assignEditableScorecardProperties(completedScorecard, setValue);
    }
  };

  return (
    <RowCTAContainer>
      <Controller
        name="completed_scorecard_id"
        render={({ field: { onChange } }) => (
          <StyledLink
            sx={{ paddingRight: theme.spacing(3) }}
            onClick={(event) => handleEditClick(event, onChange)}
            data-testid={ATSConnectHiringRequestCandidateFeedbackTestIds.REMIND_OR_EDIT_BUTTON}
          >
            {isComplete ? 'Edit' : 'Finish'}
          </StyledLink>
        )}
      />

      <StyledLink
        onClick={handleDeleteClick}
        data-testid={ATSConnectHiringRequestCandidateFeedbackTestIds.DELETE_BUTTON}
      >
        Delete
      </StyledLink>
    </RowCTAContainer>
  );
};
